var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from '@ngrx/store';
import { GET_ADDRESS_BOOK_SUCCESS, RESET_ADDRESS_BOOK, SET_ADDRESS_BOOK_PARAMS } from './address-book.actions';
import { defaultAddressBookPager } from './address-book-params.interface';
export var initialState = {
    addressBook: {
        total: 0,
        data: []
    },
    params: {
        sortBy: 'contactName',
        pager: defaultAddressBookPager
    }
};
export function addressBookReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_ADDRESS_BOOK_SUCCESS:
            return __assign({}, state, { addressBook: action.payload });
        case SET_ADDRESS_BOOK_PARAMS:
            return __assign({}, state, { params: action.payload });
        case RESET_ADDRESS_BOOK:
            return __assign({}, initialState);
        default: {
            return state;
        }
    }
}
export var getAddressBookMainState = function (state) { return state.addressBook; };
export var getWholeAddressBookState = function (addressBookState) { return addressBookState; };
export var getWholeAddressBookSelector = createSelector(getAddressBookMainState, getWholeAddressBookState);
